





















































import { Component, Mixins, Prop } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import FormOrganizationInput from '@/components/registration/common/FormOrganizationInput.vue';
import RequiredFieldValidator from '@/components/registration/common/validation/RequiredFieldValidator.vue';
import { WorkHistoryModel } from '@/interfaces/registration/models/WorkHistoryModel';
import { WorkHistoryItem } from '@/interfaces/registration/WorkHistoryItem';
import { ListOption } from '@/interfaces/registration/ListOption';
import { Organization } from '@/interfaces/registration/Organization';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

@Component({
  components: {
    FormOrganizationInput,
    RequiredFieldValidator
  }
})
export default class WorkHistoryListing extends Mixins(FormFieldMixin) {
  @Prop({ default: () => { return {}; } }) readonly value!: WorkHistoryModel;

  $refs!: {
    inputTitle: Array<HTMLFormElement>;
  };

  @utils.State
  public years!: Array<ListOption>;

  public removeWorkHistory (index: number): void {
    if (this.value.workHistoryItems[index].id as number > 0) {
      this.value.workHistoryItems[index].delete = true;
    } else {
      this.$emit('input', { workHistoryItems: this.value.workHistoryItems.filter((value, i) => i !== index) });
    }
  }

  public addWorkHistory (organization: Organization): void {
    if (organization !== undefined) {
      const newWorkHistoryItem: WorkHistoryItem = {
        id: 0,
        organization: organization
      };

      this.$emit('input', { workHistoryItems: [...this.value.workHistoryItems, ...[newWorkHistoryItem]] });

      this.$nextTick(() => this.$refs.inputTitle[this.$refs.inputTitle.length - 1].focus());
    }
  }

  get validationValue (): string {
    return this.value == null || this.value.workHistoryItems == null || this.value.workHistoryItems.length === 0 ? '' : 'valid';
  }
}
